import { IDeleteTermoEPIUseCase } from "../../../presentation/useCases/delete/delete_termo_EPI_use_case";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";


export class DeleteTermoEPIUseCase implements IDeleteTermoEPIUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) { }

  async execute(idTermoEPI: number): Promise<void> {
    await this.repository.deleteTermoById(idTermoEPI);

  }
}
